<template name="detail-nav">
	<div>
		<!-- 详情页导航栏 -->
		<div class="gp-detail-nav">
			<div class="detail-nav_option" @click="navigateBack">
				<i class="el-icon-arrow-left"></i>
				<button>返回</button>
			</div>
			<div class="detail-nav_line"></div>
			<div class="detail-nav_title">{{title}}</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				
			};
		},
		props: {
			title: {
				type: String,
				default: "详情"
			}
		},
		methods: {
			navigateBack() {
				this.$emit('navigateBack')
			}
		}
	}
</script>

<style>
	.gp-detail-nav {
		height: 30px;
		padding: 15px 0;
		display: flex;
		align-items: center;
		border-bottom: 1px solid #EEEEEE;
	}
	
	.detail-nav_option {
		padding: 0 15px;
		height: 100%;
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #333333;
		line-height: 24px;
		display: flex;
		align-items: center;
		cursor: pointer;
	}
	
	.detail-nav_option button {
		padding: 0;
		margin: 0;
		margin-left: 12px;
		background: unset;
		border: unset;
		cursor: pointer;
	}
	
	.detail-nav_line {
		width: 1px;
		height: 15px;
		background: #CCCCCC;
	}
	
	.detail-nav_title {
		padding: 0 20px;
		font-size: 18px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #666666;
		line-height: 24px;
	} 
</style>
